// extracted by css-extract-rspack-plugin
export default {"root":"WGr8eoGPgekifHzU"};